import { createFileRoute } from "@tanstack/react-router";
import { SearchParams } from "./-data/model";
import { Loading } from "@/layouts/loading";
import Component from "@/routes/(pharma)/_layout/reports/product-profitablity/-components/component";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(pharma)/_layout/reports/product-profitablity/")({
  component: Component,
  validateSearch: SearchParams,
});
